import { render, staticRenderFns } from "./EconomicEntities.vue?vue&type=template&id=2ab934c5&scoped=true"
import script from "./EconomicEntities.vue?vue&type=script&lang=js"
export * from "./EconomicEntities.vue?vue&type=script&lang=js"
import style0 from "./EconomicEntities.vue?vue&type=style&index=0&id=2ab934c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab934c5",
  null
  
)

export default component.exports